import Class from './c-flying';
import './c-flying@';

export default Class;